/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { NotificationBar as Notification } from '@pcf-engineering/pcs-ui-kit';

import * as Text from '../Text';
import RichText from '../RichText';
import { useProvince } from '../../state/ProvinceProvider';

const richTextOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => <Text.Card>{children}</Text.Card>,
    [BLOCKS.HEADING_1]: (_: any, children: any) => <Text.Card>{children}</Text.Card>,
    [BLOCKS.HEADING_2]: (_: any, children: any) => <Text.Card>{children}</Text.Card>,
    [BLOCKS.HEADING_3]: (_: any, children: any) => <Text.Card>{children}</Text.Card>,
    [BLOCKS.HEADING_4]: (_: any, children: any) => <Text.Card>{children}</Text.Card>,
    [BLOCKS.HEADING_5]: (_: any, children: any) => <Text.Card>{children}</Text.Card>,
    [BLOCKS.HEADING_6]: (_: any, children: any) => <Text.Card>{children}</Text.Card>,
  },
};

interface NotificationBarProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  notificationData: any;
}
const NotificationBar = ({ notificationData }: NotificationBarProps) => {
  const {
    bannerTitle,
    color,
    bannerCount,
    isDismissible,
    bannerContent,
    provinces,
  } = notificationData;

  const { activeProvince: province } = useProvince();

  // Does the user's selected province match the province filters from the CMS?
  const matchesProvince = useMemo(() => (
    // If there are no province filters, or the province filters contain the user's selected province, return true
    !provinces?.length || provinces.includes(province?.toUpperCase())
  ), [provinces, province]);

  return !matchesProvince ? null : (
    <Notification
      storageKey={bannerTitle}
      color={color}
      dismissible={isDismissible}
      bannerCount={parseInt(bannerCount, 10)}
      width={1280} // Remove when package has width as optional prop
    >
      {bannerContent && (
        <RichText document={bannerContent} options={richTextOptions} />
      )}
    </Notification>
  );
};

export default NotificationBar;
